export var TABLE_ACTION_CLASS_PREFIX = 'TableAction';
export var tableActionRootTestId = 'TableActionRoot';